import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { Observable, of } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { SubscriptionService } from '../services/subscription.service';
import { AuthService } from '../services/security/auth.service';

export const onboardingGuard: CanActivateFn = (): Observable<boolean> => {
  const subscriptionService = inject(SubscriptionService);
  const authService = inject(AuthService);
  const router = inject(Router);

  // First check if we have subscription status from login/token
  const subscriptionStatus = authService.subscriptionStatus;

  if (subscriptionStatus) {
    // We have subscription status from token - use it for immediate routing decision
    if (subscriptionStatus === 'active') {
      // User has active subscription - redirect to projects
      router.navigate(['/user/projects']);
      return of(false);
    }

    // Status is 'none' or 'expired' - allow access to onboarding
    return of(true);
  }

  // Fallback: If no subscription status in token, make HTTP call to get current status
  return subscriptionService.getSubscriptionStatus().pipe(
    map(response => {
      const status = response.status;

      if (status === 'active') {
        // User has active subscription - redirect to projects
        router.navigate(['/user/projects']);
        return false;
      }

      // Status is 'none' or 'expired' - allow access to onboarding
      return true;
    }),
    catchError(() => {
      // If there's an error getting subscription, allow access to onboarding
      return of(true);
    })
  );
};
